import Fuse from 'fuse.js';

import { Option } from '@/shared/lib/interfaces/option.interface';

type SearchableOption<T extends string> = Option<T> & {
	searchLabel: string;
};

const FUSE_OPTIONS = {
	keys: ['searchLabel'],
	threshold: 0.3,
	ignoreLocation: true,
};

const normalizeFuzzySearchValue = (value: string) => value.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ').trim();

export const searchOptions = <T extends string>(query: string, options: Option<T>[]) => {
	const search = normalizeFuzzySearchValue(query);

	if (!search) {
		return options;
	}

	const searchableOptions: SearchableOption<T>[] = options.map((option) => ({
		...option,
		searchLabel: normalizeFuzzySearchValue(option.label),
	}));

	const fuse = new Fuse(searchableOptions, FUSE_OPTIONS);

	return fuse.search(search).map(({ item }) => ({
		label: item.label,
		value: item.value,
	}));
};
